import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AdminActivities, COURSE_TAB, TabItem, UntilDestroy, untilDestroyed } from '@shared';
import { CourseService } from '@shared/services';
import { combineLatest, Observable } from 'rxjs';
import { CategoryV2, CourseV2, Logger, RouterStoreService } from 'thkee-common';
import { CourseHeaderComponent } from '../components/course-header/course-header.component';
import { CourseHeadingComponent } from '../components/course-heading/course-heading.component';
import { TabMenuComponent } from '../../../@shared/components/tab-menu/tab-menu.component';
import { NgTemplateOutlet } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { DrawerComponent } from '../../../@shared/components/drawer/drawer.component';
import { HistoryCourseComponent } from '../../../@shared/components/feedback/history-course/history-course.component';
const log = new Logger('CourseDetailsComponent');

@UntilDestroy()
@Component({
    selector: 'app-activities',
    templateUrl: './activities.component.html',
    styleUrls: ['./activities.component.scss'],
    imports: [CourseHeaderComponent, CourseHeadingComponent, TabMenuComponent, NgTemplateOutlet, AngularSvgIconModule, DrawerComponent, HistoryCourseComponent]
})
export class ActivitiesComponent implements OnInit {
  private store = inject(Store);
  private courseService = inject(CourseService);
  private routerStore = inject(RouterStoreService);

  courseState: string = '3';
  readOnly: boolean = true;
  modelDetails!: CourseV2;
  course$!: Observable<CourseV2>;
  categories$!: Observable<CategoryV2[]>;

  sectionEdit: boolean[] = [];
  sectionCollapse: boolean[] = [];
  courseId: string = '';
  activity_lists: Partial<AdminActivities> | undefined;
  tabItems: TabItem[] = COURSE_TAB;

  ngOnInit(): void {
    combineLatest([this.routerStore.getParam('courseId')])
      .pipe(untilDestroyed(this))
      .subscribe(([courseId]) => {
        this.courseId = courseId;
        if (courseId) {
          this.getData(courseId);
        }
      });
  }

  getData(courseId: string = '') {
    this.courseService
      .getAdminCoursesActivities({}, courseId, false)
      .pipe(untilDestroyed(this))
      .subscribe((data) => {
        this.activity_lists = data;
      });
  }
}
